import { gameConfig } from '@/app/config'
import {
  game,
  modes,
  THREE
} from '@powerplay/core-minigames'
import { Skybox } from './Skybox'

/**
 * Trieda pre prostredie
 */
export class WorldEnv {

  /** Mesh pre ciaru pre lidra */
  public lineRecord!: THREE.Mesh

  /** Mesh pre ciaru pre najlepsi hod */
  public lineBest!: THREE.Mesh

  /** obloha */
  public skybox = new Skybox()

  /** Pomocny objekt pre tiene */
  private shadowHelperObject = new THREE.Object3D()

  /**
   * Vytvorenie prostredia
   */
  public create(): void {

    console.log('VYTVARAM ENV....')
    this.skybox.create()
    this.createCameraFlashes()
    this.createLineRecord()
    this.createLineBest()
    this.createShadows()
    console.log(this.lineRecord)
    console.log('ENV vytvoreny....')

  }

  /**
   * Vytvorenie zableskov fotakov
   */
  private createCameraFlashes(): void {

    // kedze nebudeme pouzivat zablesky fotakov, tak iba dame, ze nebudu vidiet dane meshe
    const mesh = game.getMesh('env_LightFlash')
    if (!mesh) return
    mesh.visible = false

  }

  /**
   * Vytvorenie veci pre tiene
   */
  private createShadows(): void {

    game.scene.add(this.shadowHelperObject)
    game.shadowsManager.attachPlaneToObject(this.shadowHelperObject)
    this.shadowHelperObject.matrixAutoUpdate = true

  }

  /**
   * Vytvorenie ciary pre lidra
   */
  private createLineRecord(): void {

    this.lineRecord = game.getMesh('envDynamic_Javelin_DynamicLine').clone()
    this.lineRecord.position.y = 0.35
    this.lineRecord.matrixAutoUpdate = true
    const materialOriginal = this.lineRecord.material as THREE.MeshBasicMaterial
    this.lineRecord.material = materialOriginal.clone()
    const material = this.lineRecord.material as THREE.MeshBasicMaterial
    material.setValues({
      color: new THREE.Color('#ed2b5b') // world record
    })
    if (this.lineRecord.morphTargetInfluences?.[0]) {

      this.lineRecord.morphTargetInfluences[0] = gameConfig.worldRecord / 100

    }
    game.scene.add(this.lineRecord)

  }

  /**
   * Vytvorenie ciary pre najlepsi
   */
  private createLineBest(): void {

    if (modes.isTrainingMode() || modes.isTutorial()) return

    this.lineBest = game.getMesh('envDynamic_Javelin_DynamicLine').clone()
    this.lineBest.position.y = 0.35
    this.lineBest.matrixAutoUpdate = true
    const materialOriginal = this.lineBest.material as THREE.MeshBasicMaterial
    this.lineBest.material = materialOriginal.clone()
    const material = this.lineBest.material as THREE.MeshBasicMaterial

    material.setValues({
      color: new THREE.Color('#fcd835'), // best
      transparent: false
    })
    game.scene.add(this.lineBest)

  }

  /**
   * Nastavenie lineBestMeters
   * @param meters - Hodnota
   */
  public setLineBestMeters(meters: number, visible: boolean): void {

    if (this.lineBest === undefined || meters <= 0) return
    this.lineBest.visible = visible
    if (this.lineBest.morphTargetInfluences?.[0] !== undefined) {

      this.lineBest.morphTargetInfluences[0] = meters / 100

    }

  }

  /**
   * Nastavenie pozicie pre tiene
   * @param posX - Pozicia na osi X
   * @param posZ - Pozicia na osi Z
   */
  public manageShadowsPosition(posX: number, posZ: number): void {

    // menime poziciu
    this.shadowHelperObject.position.set(posX, 0.01, posZ)

  }

  /**
   * Aktualizovanie veci spolu s animaciami, teda na FULL FPS
   * @param elapsedTime - Kolko casu uplynulo, kvoli shaderom
   */
  public updateWithAnimations(elapsedTime: number): void {

    this.skybox.update(elapsedTime)

  }

  /**
   * Aktualizovanie veci v normalnom internom FPS
   */
  public update(): void {

    // zatial nic

  }

  /**
   * Resetovanie veci
   */
  public reset(): void {

    // nemusime riesit nic zatial

  }

}

export const worldEnv = new WorldEnv()
